/* src/app/features/modalidade_garantia/modal-taxa-atualizacao-garantia/modal-taxa-atualizacao-garantia.component.scss */
.alert {
  margin-top: 1em !important;
}
/*# sourceMappingURL=modal-taxa-atualizacao-garantia.component.css.map */
